// @ts-nocheck
import { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const checkoutOrderTotalItemStyles = (lastChildPosition: number | null = null, padding = 10) => {
    return css`
        ${() => {
            if (lastChildPosition && lastChildPosition > 1) {
                return css`
                    &:nth-last-child(${lastChildPosition}) {
                        padding: ${padding}px 0;
                        border-bottom: 1px solid ${getColor("common.border")};
                    }
                    &:not(:nth-last-child(${lastChildPosition})) {
                        padding: ${padding}px 0;
                        border-bottom: 1px solid ${getColor("common.border")};
                    }
                `;
            }

            return css`
                 {
                    padding: ${padding}px 0;
                    border-bottom: 1px solid ${getColor("common.border")};
                }
            `;
        }}
    `;
};

export const commonGridItemStyles = () => {
    return css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 2rem;
    `;
};

export const checkoutBackLinkStyles: LinkPresentationProps = {
    typographyProps: {
        css: css`
            ${linkStyles("secondary", "secondary", false, true)};
            font-size: ${x => x.theme.design.typography.size.large};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    icon: {
        iconProps: {
            color: "secondary",
            size: 30,
            src: ChevronLeft,
            css: css`
                margin-right: 0;
            `,
        },
    },
    css: css`
        margin-top: ${pxToRem(25)};
    `,
};
